<div class="body-container">
  <div class="content-header rm_header"></div>
  <div class="version_container">
    <!-- `app-expansion-panel` n'accepte qu'un `title: string` (manque A22) : la date
         est donc repliée dans le titre, et `mat-list` — sans équivalent au kit —
         devient une liste simple. -->
    @for (item of x; track item.version) {
      <app-expansion-panel
        [title]="item.version + ' — ' + (item.date | date)"
        [expanded]="$index === 0"
        class="version"
      >
        <div class="content">
          <ul role="list" class="liste_version">
            @for (content of item.content; track content) {
              <li class="list_content">
                <div class="content_item">{{ content }}</div>
              </li>
            }
          </ul>
        </div>
      </app-expansion-panel>
    }
  </div>
</div>
